/**
 * ExportFormatPicker — output format selection (CSV or XLSX) per plan section 28/34.
 */
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { resolveTKey } from '../../../i18n/resolve-key';

export type ExportFormat = 'csv' | 'xlsx';

export interface ExportFormatPickerProps {
  value: ExportFormat;
  onChange: (format: ExportFormat) => void;
  availableFormats?: ExportFormat[];
}

const DEFAULT_FORMATS: ExportFormat[] = ['xlsx', 'csv'];

const FORMAT_LABELS: Record<ExportFormat, string> = {
  xlsx: 'Excel (.xlsx)',
  csv: 'CSV (.csv)',
};

export function ExportFormatPicker({
  value,
  onChange,
  availableFormats = DEFAULT_FORMATS,
}: ExportFormatPickerProps) {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {t(resolveTKey('tableExport.format.title'))}
      </Typography>
      <RadioGroup
        value={value}
        onChange={(_, v) => onChange(v as ExportFormat)}
        aria-label={t(resolveTKey('tableExport.format.title'))}
      >
        {availableFormats.map((format) => (
          <FormControlLabel
            key={format}
            value={format}
            control={<Radio size="small" />}
            label={FORMAT_LABELS[format]}
          />
        ))}
      </RadioGroup>
    </Box>
  );
}
